import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTableCell]',
  standalone: true
})
export class TableCellDirective {
  @Input('appTableCell') columnId!: string;

  constructor(public templateRef: TemplateRef<any>) {}
}